import { X } from 'lucide-react';
import { useState } from 'react';
import api from '../../api';

export default function AddTopicModal({ handleClose }) {
    const [topicName, setTopicName] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSave = async () => {
        if (!topicName.trim()) {
            return; // Don't save empty topic names
        }

        setIsLoading(true);
        try {
            const response = await api.post('/admin/add-topic', {
                name: topicName,
            });
            if (response.data.statusCode === 200) {
                handleClose({modalName : "topic"});
            } else {
                console.error('Failed to add topic:', response.data.message);
            }
        } catch (error) {
            console.error('Error adding topic:', error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="modal modal-open">
            <div className="modal-box relative max-w-md">
                {/* Header */}
                <div className="flex items-center justify-between mb-6">
                    <h2 className="text-xl font-bold flex items-center gap-2">
                        Add Topic
                    </h2>
                    <button
                        onClick={() => handleClose({ modalName: '' })}
                        className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2"
                    >
                        <X className="w-4 h-4" />
                    </button>
                </div>

                {/* Form */}
                <div className="form-control w-full mb-6">
                    <label className="label">
                        <span className="label-text">Topic Name</span>
                    </label>
                    <input
                        type="text"
                        placeholder="Enter topic name"
                        className="input input-bordered w-full"
                        value={topicName}
                        onChange={(e) => setTopicName(e.target.value)}
                    />
                </div>

                {/* Actions */}
                <div className="modal-action">
                    <button
                        className="btn btn-ghost"
                        onClick={handleClose}
                        disabled={isLoading}
                    >
                        Cancel
                    </button>
                    <button
                        className="btn btn-primary"
                        onClick={handleSave}
                        disabled={!topicName.trim() || isLoading}
                    >
                        {isLoading ? (
                            <span className="loading loading-spinner loading-sm"></span>
                        ) : (
                            'Save'
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
}
